import * as THREE from 'three';
/**
 * Shared geometry for the in-scene monitor screen. Single source of truth so
 * MonitorScreen (builds the iframe plane), GamerSetup (builds the bezel/stand
 * around it) and CameraKeyframes (frames the auto-zoom) never drift apart.
 *
 * The height stays fixed (720) so the auto-zoom framing top/bottom never
 * changes; the WIDTH stretches to the browser window's aspect ratio (never
 * narrower than 16:9) so the zoomed-in screen fills the window edge to edge
 * instead of leaving empty bands left/right. SCREEN_SIZE.w is re-fitted on
 * every window resize (see fitScreenToViewport / World.resize).
 */
const SCREEN_H = 720;
export const BEZEL_T = 28; // bezel thickness, shared with GamerSetup
const MIN_ASPECT = 16 / 9;
const MAX_ASPECT = 3; // ultra-wide cap so the screen doesn't get absurd
// Visible width minus a bezel on each side, so the TV frame shows on all
// 4 sides with the same thickness as the top/bottom headroom.
function screenWidthFor(viewW, viewH) {
    const aspect = THREE.MathUtils.clamp(viewW / viewH, MIN_ASPECT, MAX_ASPECT);
    return Math.round((SCREEN_H + BEZEL_T * 2) * aspect - BEZEL_T * 2);
}
export const SCREEN_SIZE = {
    w: screenWidthFor(window.innerWidth, window.innerHeight),
    h: SCREEN_H,
};
/** Re-fit the screen width to a new viewport. Returns true if it changed. */
export function fitScreenToViewport(viewW, viewH) {
    const w = screenWidthFor(viewW, viewH);
    if (w === SCREEN_SIZE.w)
        return false;
    SCREEN_SIZE.w = w;
    return true;
}
// The monitor stand's neck runs from the desk top up to the bottom of the
// panel. It used to be ~1042 tall (screen floating at y=950); it is now a
// third of that, and the screen is lowered so it still sits on the stand.
// DESK_TOP_Y is the desk surface in world units, measured from the baked room.
const DESK_TOP_Y = -452;
const ORIGINAL_NECK_H = 1042;
export const STAND_NECK_H = ORIGINAL_NECK_H / 3;
export const SCREEN_POSITION = new THREE.Vector3(0, DESK_TOP_Y + STAND_NECK_H + SCREEN_H / 2, 255);
export const SCREEN_TILT_X = -3 * THREE.MathUtils.DEG2RAD;
// Camera vertical FOV, must match Camera.setInstance().
export const CAMERA_FOV = 35;
